
<button
  :class="'BareIconButton Clickable ' + (classExtra || '')"
  v-on:click="onClick"
>
  <img :src="'/img/icons/' + iconFalse + '.svg'" v-if="!value" />
  <img :src="'/img/icons/' + iconTrue + '.svg'" v-if="value" />
</button>
